import { DsPinUserRightsInterface } from '../interfaces/ds-pin-user-rights.interface';

export class DsPinUserRights {
  /**
   * Can link company right.
   */
  public canLinkCompany: boolean;

  /**
   *
   */
  public canAdd: boolean;

  /**
   *
   */
  public canView: boolean;

  /**
   *
   */
  public canEdit: boolean;

  /**
   *
   */
  public canComment: boolean;

  /**
   *
   */
  public canSetStatus: [
    {
      /**
       *
       */
      0: boolean;
      /**
       *
       */
      1: boolean;
      /**
       *
       */
      2: boolean;
      /**
       *
       */
      3: boolean;
      /**
       *
       */
      4: boolean;
      /**
       *
       */
      5: boolean;
      /**
       *
       */
      6: boolean;
    }
  ];

  /**
   * Creates an instance of DsPin.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsPinUserRightsInterface) {
    this.canLinkCompany = jsonData.canLinkCompany;
    this.canAdd = jsonData.canAdd;
    this.canComment = jsonData.canComment;
    this.canEdit = jsonData.canEdit;
    this.canView = jsonData.canView;
    this.canSetStatus = jsonData.canSetStatus;
  }
}
